import Vue from 'vue';
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate);
Vue.config.productionTip = false;

/*eslint-disable */
VeeValidate.Validator.extend('verify_password', {
  getMessage: field =>{
    return field + ' must contain at least 8 characters consisting of at least 1 uppercase letter, 1 lowercase letter, 1 special character, and 1 number.';
  },
  validate: value => {
    var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
    return strongRegex.test(value);
  }
});

// only validate 2 country code us and ca
VeeValidate.Validator.extend('validate_country_code', {
    getMessage: field =>{
      return field + ' value must be CA or US';
    },
    validate: value => {
      return ['CA', 'US'].includes(value);
    }
 });
VeeValidate.Validator.extend('validate_state_code', {
  getMessage: field =>{
    return 'Please enter valid state ex : ON, FL, CA';
  },
  validate: value => {
    let canadaState = ['AB', 'BC', 'MB', 'NB', 'NL', 'NT', 'NS', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT'];
    let usState = ['AL','AK','AZ','AR','CA','CO','CT','DE','DC','FL','GA','HI','ID','IL','IN','IA','KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT','VA','WA','WV','WI','WY'];
    let usStateNext = ['AS','GU','MP','PR','UM','VI'];
    let allStates = [...canadaState, ...usState, ...usStateNext];
    return allStates.includes(value);
  }
});

// VeeValidate.Validator.extend('required', {
//   getMessage: field => 'The ' + field + ' is required.',
//   validate: value => value
// });
VeeValidate.Validator.extend('must_be_checked', {
  getMessage: field => 'The ' + field + ' is required.',
  validate:(value) => {
    if(value === true){
      return true;
    }
    return false;
  }
});


// VeeValidate.Validator.extend('email', {
//   getMessage: field => 'The ' + field + ' must be valid.',
//   validate: value => {
//     return value && /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)
//   }
// });

VeeValidate.Validator.extend('phone_number', {
  getMessage: field => `Please enter a valid 10 digit phone number.`,
  validate: value => {
      return value.length == 10;
  },
});

VeeValidate.Validator.extend('phone_number_only_if_has_value', {
  getMessage: field => `Please enter a valid 10 digit phone number.`,
  validate: value => {
     if(value == '') {
       return true;
     } else {
      return value.length == 10;
     }
  },
});



/**
 * Components globally
 */

 Vue.component('ValidationProvider', VeeValidate.ValidationProvider);
 Vue.component('ValidationObserver', VeeValidate.ValidationObserver);